import React from 'react'; 
import './Victory-Of-Light.css'; 
import Navbar from '../../Navbar/Navbar'; 
import '../../Button.css'; 

function VictoryOfLight() {
  window.scrollTo(0, 0);
    return (
      <>
          
          <div className="Victory-Of-Light"> 

          <form method="get" action="#/victory-of-light-mandarin"> 
            <button id="the-button" type='btn'>普通話</button> 
          </form> 

            <h1 className="exhibition">Victory of Light Exhibition</h1> 
            <hr /> 

            <h6 id="head">
              Organizers: 
            </h6>
            <p id="points">
              Asian American Culture Media Group
            </p>
            <p id="points">
              American Dragon International Fine Art 
            </p>

            <h6 id="head">
              Contractors: 
            </h6>
            <p id="points">
              The Wall Street Art Space
            </p> 

            <h6 id="head">
              Curators: 
            </h6>
            <p id="points">
              Lena Liu 
            </p>
            <p id="points">
              Apelles Zhou 
            </p> 
            <br></br>

            <h2 id="header-thing">
              OPENING RECEPTION, FEBRUARY 8, 2020; 3:30 P.M. 
              </h2> 
              <p id="art-paragraph-other">
              Fifteen artists from nine countries will showcase their engaging photographs, paintings, 
              and installation / sculpture works of art that will be included in the next exhibition, 
              the International Light and Shadow Art Exhibition, 2020.   This exhibition will take place 
              from February 8, 2020 through March 9, 2020.  The earth will transition to the Aquarius 
              Era during this Wall Street Art Space exhibition. 
              </p> 
              <p id="art-paragraph-other">
              Asian American Culture Media Group and American Dragon International Fine Art, LLC, have 
              achieved great success due to the integration of these two institutions, featuring a Cultural 
              Education Center and Art Gallery.  We use this business model to complement economic and 
              cultural advantages.  Our perfect location on Wall Street and The Trinity can represent material 
              and spiritual harmony.  Some of our clients are from the financial industry, including Mr. Stephen 
              Rockefeller.  These clients participate on a regular basis in support of our Art Exhibitions, 
              and we have cultivated a large group of collectors from this social circle. 
              </p> 
              <p id="art-paragraph-other">
              At the opening reception on Saturday, February 8, 2020, we will host a concert to further integrate 
              the event with our cultural values, as well as help to attract more clients and collectors. The 
              exhibition will include 40 works from the talented artists. 
              </p> 
              <br /> 

              <img src="./Vol1.jpeg" id="image-thing"></img>
              <h5 id="caption-thing">Oil on Canvas</h5> 
              <h5 id="caption-thing">29" x 50"</h5> 
              <h5 id="caption-thing">$7,300.00</h5> 
              <h5 id="caption-thing">Aparna Banerjee</h5> 
              <br /> 

              <img src="./Vol2.jpeg" id="image-thing"></img>
              <h5 id="caption-thing">The Age of Aquarius</h5> 
              <h5 id="caption-thing">Oil and Acrylic on Canvas</h5> 
              <h5 id="caption-thing">18" x 24"</h5> 
              <h5 id="caption-thing">$1,500.00</h5> 
              <h5 id="caption-thing">Apelles Zhou</h5> 
              <br /> 

              <img src="./Vol3.jpeg" id="image-thing"></img>
              <h5 id="caption-thing">Through the Picture</h5> 
              <h5 id="caption-thing">Oil on Canvas</h5> 
              <h5 id="caption-thing">39" x 39"</h5> 
              <h5 id="caption-thing">$10,000.00</h5> 
              <h5 id="caption-thing">Rosana Largo Rodriguez</h5> 
              <br /> 

              <img src="./Vol4.jpeg" id="image-thing"></img>
              <h5 id="caption-thing">Sky Dust</h5> 
              <h5 id="caption-thing">Hand Jacquard Woven Cotton, Hand Dyed Kid Mohair, Silk, Metallic, Plastic, and Holographic Yarns</h5> 
              <h5 id="caption-thing">18" x 21" x 1"</h5> 
              <h5 id="caption-thing">$3,500.00</h5> 
              <h5 id="caption-thing">Robin Kang</h5> 
              <br /> 

              <img src="./Vol5.jpeg" id="image-thing"></img>
              <h5 id="caption-thing">Paint Can Mouse</h5> 
              <h5 id="caption-thing">Acrylic on Wood Panel</h5> 
              <h5 id="caption-thing">36" x 48"</h5> 
              <h5 id="caption-thing">$4,000.00</h5> 
              <h5 id="caption-thing">Pitch Blac</h5> 
              <br /> 

              <img src="./Vol6.jpeg" id="image-thing"></img> 
              <h5 id="caption-thing">Offerings</h5> 
              <h5 id="caption-thing">Oil on Canvas</h5> 
              <h5 id="caption-thing">30" x 30"</h5> 
              <h5 id="caption-thing">$1,600.00</h5> 
              <h5 id="caption-thing">Imaing Clyde</h5> 
              <br /> 

              <img src="./Vol7.jpeg" id="image-thing"></img>
              <h5 id="caption-thing">Silver Water</h5> 
              <h5 id="caption-thing">Mixed Media Paper, Ink, Heavy Gloss Acrylic Varnish, Glass, Wood Framing</h5> 
              <h5 id="caption-thing">13” x 16” X 0.75"</h5> 
              <h5 id="caption-thing">$975.00</h5> 
              <h5 id="caption-thing">Denise Cummings</h5> 
              <br /> 

              <img src="./Vol8.jpeg" id="image-thing"></img>
              <h5 id="caption-thing">Full Moon II</h5> 
              <h5 id="caption-thing">Acrylic on Panel</h5> 
              <h5 id="caption-thing">24" x 18"</h5> 
              <h5 id="caption-thing">$1,800.00</h5> 
              <h5 id="caption-thing">Calli Moore</h5> 
              <br /> 

              <img src="./Vol9.jpeg" id="image-thing"></img>
              <h5 id="caption-thing">Travel Around the World Dreaming</h5> 
              <h5 id="caption-thing">Mixed Media on Paper</h5> 
              <h5 id="caption-thing">28" x 32"</h5> 
              <h5 id="caption-thing">$2,900.00</h5> 
              <h5 id="caption-thing">Hyelim Chang</h5> 
              <br /> 

              <img src="./Vol10.jpeg" id="image-thing"></img>
              <h5 id="caption-thing">Acrylic on Canvas</h5> 
              <h5 id="caption-thing">36" x 35"</h5> 
              <h5 id="caption-thing">$4,500.00</h5> 
              <h5 id="caption-thing">Chadwick</h5> 
              <br /> 

              <img src="./Vol11.jpeg" id="image-thing"></img>
              <h5 id="caption-thing">12 Arch Angels of The Central Sun</h5> 
              <h5 id="caption-thing">Oil on Canvas</h5> 
              <h5 id="caption-thing">48" x 48"</h5> 
              <h5 id="caption-thing">$5,000.00</h5> 
              <h5 id="caption-thing">Ryan Michael Ford</h5> 
              <br /> 

              <img src="./Vol12.jpeg" id="image-thing"></img>
              <h5 id="caption-thing">The Light of My Life</h5> 
              <h5 id="caption-thing">Acrylic on Canvas</h5> 
              <h5 id="caption-thing">30" x 30"</h5> 
              <h5 id="caption-thing">$2,499.00</h5> 
              <h5 id="caption-thing">Barbara Muir</h5> 
              <br /> 

              <img src="./Vol13.jpeg" id="image-thing"></img>
              <h5 id="caption-thing">A Mouthful</h5> 
              <h5 id="caption-thing">Mixed Media Paper, Ink, Heavy Gloss Acrylic Varnish, Glass, Wood Framing</h5> 
              <h5 id="caption-thing">12” x 15” x 0.75”</h5> 
              <h5 id="caption-thing">$775.00</h5> 
              <h5 id="caption-thing">Denise Cummings</h5> 
              <br /> 

              <img src="./Vol14.jpeg" id="image-thing"></img>
              <h5 id="caption-thing">L'uccello Maria</h5> 
              <h5 id="caption-thing">Textured Acrylic on Unframed Stretched Canvas</h5> 
              <h5 id="caption-thing">24" x 30"</h5> 
              <h5 id="caption-thing">$3,000.00</h5> 
              <h5 id="caption-thing">Lightning Yumeku</h5> 
              <br /> 
              
          </div>
        </> 
    );
  }
  
  export default VictoryOfLight;